import { render, staticRenderFns } from "./contestQuizzort.html?vue&type=template&id=534fb915&scoped=true&"
import script from "./contestQuizzort.js?vue&type=script&lang=js&"
export * from "./contestQuizzort.js?vue&type=script&lang=js&"
import style0 from "./contestQuizzort.scss?vue&type=style&index=0&id=534fb915&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fb915",
  null
  
)

export default component.exports